export const configurationOwnerUsernameLabel =
  'io.portainer.kubernetes.configuration.owner';
